'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _querystring = require('querystring');

exports.default = function (location) {
  if (location && location.search) {
    var webviewParam = (0, _querystring.parse)((location.search || '').substr(1)).webview ? 'webview=1&' : '';
    return '/login?' + webviewParam + 'returnTo=' + encodeURIComponent(location.pathname + location.search);
  }

  return '/login' + (location ? location.pathname : '');
};